export default __webpack_public_path__ + "static/inbox-page-provider-f947e277d2e9300f62a61566b5cda0c1.png";